/**
 * created by tian ruo jun
 * 2022/04/15
 * 稿件编辑器
 * 用于打开网站稿件或1.1.1版本稿件：1、投稿稿件被编辑提取至栏目的稿件；2、直接在媒体栏目下写稿的稿件；
 */
import React, {Component} from 'react';
import {Button, Input, message, Modal, Icon, Tree, TreeSelect} from "antd";
import Editor from '../Editor'
import ButtonList from "../components/activitiAndBtn/ButtonList";
import {EditorInformationOfWebEditor as EditorInformation} from './components/EditorInformationOfWebEditor';
import EditorPublishInformation from "../components/EditorPublishInformation";
import BaseComponent from "../../../base/BaseComponent";
import {informationConfig, formItemSizeConfig} from "./form/information-config";
import {publishInformationConfigFn} from "./publish/publishInformation-config";
import {base64Encode} from "../../../utils";
import {getInfoFromLocalStorage} from "../../../actions";
import {removeContentSecurity} from "../floatTool/securityCheck";
import SyncModal from "../../../view/components/syncModal/syncModal";
import LinkCheck from "../components/pluginsSpace/linkCheck/linkCheck";
import {Scrollbars} from "react-custom-scrollbars";
import MediaList from "../../newsContribute/component/modal/mediaList";
import {systemBaseEvent} from "../../../base/baseEvent";
import RmtPopconfirm from "../../components/rmtPopconfirm/rmtPopconfirm";
import DiscardReason from '../components/discardReason/discardReason';

// import EditorInformation from "../components/EditorInformation";
const {TextArea} = Input;
const { TreeNode } = TreeSelect;
const topBtnHeight = 64;//顶部按钮高度

export default class WebEditor extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            id: this.props.id,//稿件id和uuid
            contentText: "",//稿件内容
            activityOption: {},// 审核流所需参数
            informationStatus: true,//基本信息的展开状态
            editorShowStatus: true,//编辑器输入区域显示状态
            mediaId: "",
            treeId: "",
            contentId: "",
            storyType: "",
            checkMainColumn: false, // 校验主栏目回显
            showRemarks: false,
            remarks:"",
            publishMediaListModalVisible: false, // 查看发布弹窗
            publishMediaListData: [], // 发布链接列表
            showPublishMediaListModalBtn: false, // 是否展示查看发布按钮
            isLockedData:{},//锁住的信息
            undo: false,
            hasMore: false,
            treeNodeWithdrawVisible: false,
            isDelete: false,
            discardReasonList: [
                { key: 1, value: 1, label: '文字问题' },
                { key: 2, value: 2, label: '格式问题' },
                { key: 3, value: 3, label: '图片问题' },
                { key: 4, value: 4, label: '链接问题' },
            ]
        };

        if (this.urlParams) {
            let treeId = this.urlParams.treeId;
            let mediaId = this.urlParams.mediaId;
            if(!mediaId && this.urlParams.webStory && this.urlParams.webStory.mediaId) {
                mediaId = this.urlParams.webStory.mediaId;
            }

            let contentId = this.urlParams.contentId;
            let checkMainColumn = this.urlParams.checkMainColumn;
            if(mediaId || treeId || contentId) {
                this.setIds({mediaId,treeId,contentId,checkMainColumn});
            }
        }
        window.ueditor.dataType = "website";
        window.ueditor.setCurrentInformation = (data)=>{
            this.setCurrentInformation(data);
        };

        if(this.state.id){
            systemBaseEvent.syncPlaybackExec("editorUpdateData");//广播编辑器中当前是修改稿件
        }
        systemBaseEvent.syncPlaybackExec("editorIdChange", {editorId: this.props.id});//广播编辑器中的当前id
        systemBaseEvent.syncPlaybackExec("editorAjaxShowDataUrlChange", "/cm-sites-pms/website/news/getById?webNewsId=");//广播ajax获取数据的方式
    }

    componentWillMount() {
        let id = this.getStoryId();
        this.state.id = id;
        if(!id && !(this.urlParams?.webStory)) {
            this.initActivitiConfig({});
        }
    }

    /**
     * 设置父页面传过来的参数作为编辑器中的数据回显
     */
    initParentData() {
        if (this.urlParams) {
            this.state.operateType = this.urlParams.operateType;
            this.state.storyId = this.urlParams.storyId;
            if(this.urlParams.webStory){
                this.state.webStory = this.urlParams.webStory;
                let id = (this.props.id && this.props.id.length > 1 && this.props.id != 'null' && this.props.id != 'undefined') ? this.props.id : '';
                if(!id) {
                    this.setStoryByData(this.state.webStory);
                }
            }
            this.setState({});
        }
    }
    activitiBtns;
    /**设置流程配置*/
    async initActivitiConfig(story,call) {
        let id = (this.props.id && this.props.id.length > 1 && this.props.id != 'null' && this.props.id != 'undefined') ? this.props.id : '';
        this.state.id = id;
        let that = this;
        let account = (window.currentUser && window.currentUser.account) ? window.currentUser.account : "";
        let userId = (window.currentUser && window.currentUser.id) ? window.currentUser.id : "";
        // if(
        //     id &&
        //     (!story.id || story.id!=id)
        // ) {
        //     return false
        // }
        let publishConfig = this.sysConfigGetValueByKey("materialCenter.publishBtn.exclude", "已发布");
        let mustNotShowPublishBtn1 = (story.statusName && publishConfig.indexOf(story.statusName)>-1)?false:true;
        let mustNotShowPublishBtn2 = that.urlParams && that.urlParams.mustNotShowPublishBtn ? that.urlParams.mustNotShowPublishBtn : false;
        // 判断操作权限start
        let showBtnFlag = true;
        // let currentMediaList = getInfoFromLocalStorage("currentMediaList");
        // if(!currentMediaList) {
        //     currentMediaList = await this.getCurrentMediaList()
        // }
        // if(currentMediaList && currentMediaList.length) {
        //     if(this.state.mediaId) {
        //         if(currentMediaList.find(item=>item&&item.mediaList&&item.mediaList.find(item2=>item2.id===this.state.mediaId))){
        //             showBtnFlag = true;
        //         }
        //     } else {
        //         showBtnFlag = true;
        //     }
        // }
        // 判断操作权限end

        // 重置流程条件start
        let againFlag = false;
        if(!id && that.urlParams.storyId) {
            // 当前稿件无id，但是投稿稿件存在id，需要用旧id重启流程
            againFlag = true;
            // id = that.urlParams.storyId;
        }
        let reloadStatus = this.sysConfigGetValueByKey("webNews.activiti.reload.status", "");
        if(story.statusName && reloadStatus.indexOf(story.statusName) > -1) { // 弃用状态重启审核流
            againFlag = true;
        }
        let activitiConf = this.urlParams ? {type: this.urlParams.activitiConfName} : null;
        // 如果草稿稿件可以被创建人之外的人看到，则需要手动控制审核流不要重启
        if(story && story.statusName === "草稿" && story.creator !== userId) {
            // 当稿件状态为草稿时，审核流会自动重启，此时将activitiConf置空则审核流不重启
            activitiConf = null
        }
        // 重置流程条件end
        this.state.activityOption = {
            id:that.getActId(id),//流程id
            activitiConf,//流程conf
            pojoName: 'webNews',//数据表name
            userAccount: account,//当前用户account
            showBtnFlag,//是否显示流程按钮
            againFlag:that.getAgainFlag(story,id),//重置流程的判断条件
            showAfterFuns: {
                // call({code: 1});
                // call({code: 0, log: "非投稿稿件！"});
                // call({code: -1, log: "未获取到采访任务信息，请重新打开再试！"});
                /**
                 * 是否是投稿稿件来源（返回写稿人按钮显隐判定）
                 */
                fromContribute: (item, call) => {
                    that.request({
                        url: "/cm-sites-pms/story/renderStoryByWbNews",
                        body: {webNewsId: id},
                        loading:false,
                        callBack: (res) => {
                            if(res) {
                                call({code: 1});
                            } else {
                                call({code: 0, log: "非投稿稿件！"});
                            }
                        }
                    });
                    // if(that.state.operateType && that.state.operateType === "contribute") {
                    //     call({code: 1});
                    // } else {
                    //     call({code: 0, log: "非投稿稿件！"});
                    // }
                },
                /**
                 * 弃用
                 */
                abandon: (item, call) => {
                    if(id) {
                        call({code: 1});
                    } else {
                        call({code: 0, log: "新增稿件没有弃用权限！"});
                    }
                },
                /**
                 * 是否显示撤回按钮
                 */
                callBackBtnShow: (item, call) => {
                    // 素材中心稿件标题进入的稿件
                    if(that.state.operateType && that.state.operateType === "contribute") {
                        let activitiConfName = that.sysConfigGetValueByKey("editor.activiti.goBack.states", "已返回写稿人,返回写稿人");
                        // 稿件状态为返回写稿人
                        if(story && story.statusName && activitiConfName.includes(story.statusName)) {
                            call({code: 0, log: "不显示撤回按钮！"});
                            return
                        }
                    }
                    call({code: 1});
                },
            },//流程按钮加载前置js
            getTextRequisite: false,//备注是否必填
            otherJs: {
                /**
                 * 返回流程初始创建人js
                 * @param activiti
                 * @param buttonConf
                 * @param call
                 */
                returnsProcessCreator: (activiti, buttonConf, call) => {
                    let myId = (window.currentUser && window.currentUser.account) ? window.currentUser.id : "";
                    that.getProcessHistory(id,(list)=>{
                        if(list&&list.length) {
                            let userInfo = list.at(-1) || {};
                            let userId = userInfo.operatorUserInfo.userId;
                            let userName = userInfo.operatorName;
                            let deptId = userInfo.operatorUserInfo.deptId;
                            if (myId === userId) {
                                message.warning("当前稿件写稿人与当前操作人是同一人，无需返回");
                                window.loading.hide();
                                return false;
                            }
                            activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = [{
                                id: userId,
                                deptId
                            }];
                            call({code: 1, log: "查询到返回者为：" + userName});
                        } else {
                            message.warning("审核流记录查询失败！");
                            window.loading.hide();
                        }
                    });
                },
                /**
                 * 返回稿件创建人js
                 * @param activiti
                 * @param buttonConf
                 * @param call
                 */
                setSourceUser: (activiti, buttonConf, call) => {
                    let myId = (window.currentUser && window.currentUser.account) ? window.currentUser.id : "";
                    if (myId === this.webStory.creator) {
                        message.warning("当前稿件写稿人与当前操作人是同一人，无需返回");
                        window.loading.hide();
                        return false;
                    }
                    activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = [{
                        id: this.webStory.creator,
                        name: this.webStory.creatorName,
                    }];
                    call({code: 1, log: "查询到返回者为：" + this.webStory.creator});
                },

                /**
                 * 撤稿前置js
                 * @param activiti
                 * @param buttonConf
                 * @param call
                 */
                callActRevert: function (activiti, buttonConf, call) {
                    activiti.terminate.call(activiti, function (res) {
                        if (res == true) {
                            activiti.options.statusNameTemp = "草稿";
                            activiti.endFunction(activiti, function (res) {
                                if(res){
                                    message.success("流程已撤回，稿件变为草稿状态", 1, ()=>{
                                        activiti.submitOK();
                                    });
                                }
                            })
                        }
                    });
                },
                /**
                 * 修改完成后直接提交给返回的人 不经过中间审核
                 * @param activiti
                 * @param buttonConf
                 * @param call
                 */
                callAgent: function (activiti, buttonConf, call) {
                    let uuid = activiti.options.uuid;
                    that.request({
                        url: "/cm-sites-sys/process/getProcessHistory",
                        method: "post",
                        body: {bizKey: uuid},
                        callBack: (data) => {
                            var historyList = data;
                            if (historyList && historyList.length > 1 && historyList[0].candidateInfo && historyList[0].candidateInfo.length) {
                                var callBackHistory = historyList[0];
                                activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = [{
                                    id: callBackHistory.operatorUserInfo.userId,
                                    name: callBackHistory.operatorName,
                                    deptId:  callBackHistory.operatorUserInfo.deptId,
                                }];
                                call({code: 1, log: "查询到返回者为：" + callBackHistory.candidateNames[0]});
                            } else {
                                call({code: -1, msg: "未查询到返回者！"})
                            }
                        },
                        errorCallBack: () => {
                            message.error("未查询到返回者！");
                            window.loading.hide();
                        },
                    });
                },
                /**
                 * 弃用按钮点击事件
                 */
                onClickDiscard: (activiti, buttonConf, call) => {
                    let remarksList = []
                    window.loading.hide();
                    that.syncModal.confirm({
                        title: "弃用原因",
                        width:400,
                        content:
                            <div>
                                {that.state.discardReasonList.map((item, index) => (
                                    <DiscardReason isEdit={true} data={item} callBack={({value,type}) => {
                                        remarksList.push({value,type})
                                    }} />
                                ))}
                            </div>,
                        okText: "确定",
                        cancelText: "取消",
                        onOk: ()=>{
                            const result = remarksList.reduce((acc, curr) => {
                                acc[curr.type] = curr;
                                return acc;
                            }, {});
                            const finalData = Object.values(result);
                            if (finalData.every(item => item.value.trim() === "")) {
                                message.destroy();
                                message.warning("至少填写一项弃用原因！");
                                return;
                            }
                            let data = {
                                remarks: JSON.stringify(finalData),
                                type: "remarks",
                            }
                            activiti.actForm.values.otherData = {remarks:data.remarks}
                            call({ code: 1 });
                            that.syncModal.destroy();
                            window.loading.show();
                        },
                        onCancel: ()=>{
                            that.syncModal.destroy();
                            window.loading.hide();;
                        }
                    });
                }
            },//流程按钮事件前置js
            saveFunction: that.saveStory,//稿件保存方法
            saveStatusNameFunction: that.updateStatusName,//稿件改流程状态方法
            publish: that.publish,
            onSubmitOK: function (activiti) {
                that.refresh(activiti)
            },//流程事件运行完毕的回调
            successCall: () => {
            },//流程加载完的回调
            readyCall: () => {
            },//流程初始化完的回调
            showRemarks: (remarks) => {
                let remarksData
                try {
                    remarksData = JSON.parse(remarks)
                    remarksData.forEach(item => {
                        const matchReason = this.state.discardReasonList.find(reason => reason.value === item.type);
                        if (matchReason) {
                            matchReason.text = item.value;
                        }
                    });
                } catch (error) {
                    console.log('error: ', error);
                }
                if (Array.isArray(remarksData)) {
                    this.setState({ showReason: true, remarks :remarksData})
                }else if(remarks && remarks.length) {
                    this.setState({showRemarks:true,remarks})
                }
            },//备注回显
            onlyShowBtn: true,//是否只返回流程按钮
            title: '',//流程弹窗title
            visible: false,//流程弹窗是否展示
            btnLoadOver:(btns)=>{
                this.activitiBtns = btns;
                this.setState({});
            },
            // 控制前端发布按钮的显隐
            mustNotShowPublishBtn: (mustNotShowPublishBtn1 || mustNotShowPublishBtn2) ? true : false,
            showBtnIcon: true,
            btnType: "editor",
            showLockCall: (data) => {
                // data={status: true, id: this.messageId}  true 加锁成功，只有当前人可编辑，  false 加锁失败，不可编辑，
                // 如果加锁失败，则开启遮罩
                if (!data.status) {
                    this.Editor.showLockMask(data);
                    this.state.isLockedData = data;
                    this.setState({})
                }
            },
            chooseFilterObject: function (users, call) {
                if (!users || users.length < 1) {
                    call && call(users);
                    return false
                }
                let mediaInfo = that.getChooseFilterObject();
                if(!mediaInfo) {
                    message.warning("过滤媒体权限失败，请先选择主栏目");
                    window.loading.hide();
                    return false
                }
                let receivers = users.map(item=>({
                    deptId: item.deptData[0]._id,
                    userId: item._id,
                }));
                that.request({
                    url: "/cm-sites-pms/contribute/filterUser",
                    method: "post",
                    contentType: "json",
                    loading:false,
                    body: {
                        mediaInfo,
                        receivers
                    },
                    callBack: (list) => {
                        let newUsers = [];
                        if(list&&list.length) {
                            newUsers=list
                            call && call(newUsers)
                        } else {
                            message.warning("未查到拥有媒体权限的待办用户");
                            window.loading.hide();
                        }
                    },
                    errorCallBack: () => {
                        this.error("过滤媒体权限失败,请稍后重试");
                        window.loading.hide();
                    },
                });
            },
            checkForm: that.checkForm
        };
        this.setState({});
        call&&call(this.state.activityOption)
    }

    getProcessHistory = (id, call) => {
        if (!id && call) {
            call([]);
            return false
        }
        this.request({
            url: "/cm-sites-sys/process/getProcessHistory",
            method: "post",
            body: {bizKey: id},
            callBack: (res) => {
                if (res && res.length) {
                    call(res)
                } else {
                    call([])
                }
            },
            errorCallBack: (e) => {
                window.loading.hide();
                console.log(e.toString())
            }
        })
    };

    getChooseFilterObject = () => {
        let publishData = this.getPublish();
        let {selectColumn={}} = publishData;
        let mainColumn = selectColumn&&selectColumn.mainColumn||{}; // 主栏目
        let contentId = mainColumn.contentId;
        let treeId = mainColumn.treeId;
        let mediaId = mainColumn.mediaId;
        if(!(mainColumn && contentId && treeId && mediaId)) {
            window.loading.hide();
            return false
        } else {
            return {
                contentId,
                mediaId
            }
        }
    };

    // 获取流程重置条件
    /**
     * 控制是否重启新的审核流
     * */
    getAgainFlag = (story,id) => {
        if(!id && this.urlParams.storyId) {
            // 当前稿件无id，但是投稿稿件存在id，需要用旧id重启流程
            return true;
        }
        if(id && !this.processHistory?.length && this.state.storyId) {
            return true
        }
        let reloadStatus = this.sysConfigGetValueByKey("webNews.activiti.reload.status", "");
        return story.statusName && reloadStatus.indexOf(story.statusName) > -1;
    }
    /**
     * 获取流程id
     * 当新增稿件时拾取时，需要用拾取的稿件id启动审核流
     * */
    getActId = (id) => {
        if(!id && this.urlParams.storyId) {
            return this.urlParams.storyId;
        }
        if(id && !this.processHistory?.length && this.state.storyId) {
            return this.state.storyId
        }
        return id
    }

    // 获取流程重置参数
    againAction = async ({id}) => {
        let oldUuid = await this.findOldUuid({id});
        return {
            uuid: oldUuid || id,
            againFlag: oldUuid?true:false
        }
    };

    // 收稿id获取投稿稿件id
    findOldUuid = ({id}) => {
        return new Promise(((resolve, reject) => {
            this.request({
                url: "/cm-sites-pms/story/renderStoryByWbNews",
                body: { webNewsId: id },
                loading: false,
                callBack: (res) => {
                    if(res && res.id) {
                        this.state.storyId=res.id;
                        resolve(res.id)
                    } else {
                        resolve(null)
                    }
                },
                serverVerify:{
                    serverErrorCallBack: ()=>{
                        resolve(null)
                    },
                    isShowErrorMsg:false
                }
            })
        }))
    };

    // 获取稿件流程记录
    getActServiceDataByUuid = ({id}) => {
        return new Promise(((resolve, reject) => {
            this.request({
                loading:false,
                url: "/cm-sites-activiti/activiti/getActserviceDataByUuid",
                body: {uuid: id},
                callBack: (res) => {
                    resolve(res)
                },
            })
        }))
    };

    webStory = {};
    componentDidMount() {
    }

    setIds = ({mediaId,treeId,contentId,checkMainColumn}) => {
        this.state.mediaId = mediaId;
        this.state.treeId = treeId;
        this.state.contentId = contentId;
        this.state.checkMainColumn = checkMainColumn;
    };


    componentWillUnmount() {
        // 销毁postMessage监听
        this.destroyPostMessage("EditorInformationOfWebEditor")
    }

    refresh = (activiti) => {
        let hash = window.location.hash.split('/');
        if(this.state.id && !(hash[hash.length - 1] && hash[hash.length - 1].length>1)) {
            hash[hash.length - 1] = this.state.id;
        }
        this.callPostMessage({message:'请求刷新父页面'});
        window.location.hash = hash.join('/');
        // activiti&&activiti.load.end();
        window.location.reload();
    };

    // 渲染稿件编辑器
    render() {
        return (
            <Editor
                // Editor组件暴露
                ref={(Editor) => {this.Editor = Editor}}
                // 动态参数（传递到子组件中）
                dynamicParams={{
                    editorId:this.state.id,
                    oldId:this.urlParams.storyId||this.state.storyId,
                    findOldUuid: this.findOldUuid
                }}
                // 流程按钮组件
                editorActBtn={this.renderActBtn()}
                // 稿件基本信息组件
                editorInformation={this.renderInformation()}
                // 稿件栏目设置模块
                editorRightModule={this.renderEditorPublishInformation()}
                // 编辑器加载完毕的回调
                onEditorLoadOver={()=>{
                    // 向父页面请求媒体参数或稿件参数
                    // this.callPostMessage({
                    //     message: "请求媒体参数"
                    // });
                    window.ueditor.afterSaveDataFun = [];
                    window.ueditor.addAfterSaveDataFun = function(fun){
                        window.ueditor.afterSaveDataFun.push(fun);
                    };
                    //接收参数去渲染数据  这里只能放在这里，因为必须等到编辑器加载完成了之后，才要把内容放在编辑器中
                    this.initParentData();
                    //接收id去渲染数据
                    this.getStoryById()
                }}
                // 编辑器内容改变的回调
                onEditorContentChange={(content)=>{
                    this.setState({contentText:this.getEditContentText()})
                }}
                // 基本信息展开和关闭的回调
                onInformationStatusCallBack={(status) => {this.setState({informationStatus: status})}}
                // 表单展开状态
                informationStatus={this.state.informationStatus}
                // 编辑器输入区域显示状态
                editorShow={this.state.editorShowStatus}
            />
        )
    }

    getActBtnListData (){
        // 这里不要限制打印按钮
        // if(this.urlParams && this.urlParams.hideBtn){
        //     return null;
        // }
        let {activityOption,website} = this.state;
        let id = (this.props.id && this.props.id.length > 1 && this.props.id != 'null' && this.props.id != 'undefined') ? this.props.id : '';
        if(!activityOption.pojoName) {
            return null;
        }
        let that = this;
        // 流程按钮需要的参数
        let buttonListData = {
            topBtnHeight,
            activityOption,
            saveStory: that.saveStory,
            showSave: (()=>{
                if(this.activitiBtns && (this.activitiBtns.length > 0)){
                    let configBtns = this.sysConfigGetValueByKey("web.editor.saveBtn.mutex.activiti.btn", "撤回,返回修改").split(",");
                    let result = true;
                    this.activitiBtns && this.activitiBtns.map(item=>{
                        if(configBtns.indexOf(item.name) > -1){
                            result = false;
                        }
                    });
                    return result;
                }
                //当前人没有流程按钮的时候，在以下情况下需要暂存按钮
                let id = (this.props.id && this.props.id.length > 1 && this.props.id != 'null' && this.props.id != 'undefined') ? this.props.id : '';
                if(!id) {
                    return true
                }
                let statusName = this.webStory?.statusName;
                let creator = this.webStory?.creator;
                let userId = (window.currentUser && window.currentUser.id) ? window.currentUser.id : "";
                if(statusName==="草稿" && creator===userId) {
                    return true
                }
                if(statusName==="已撤稿") {
                    return true
                }
                return false;
            })(),
            showPreview: this.webStory && this.webStory.contentId > 0,
            showPrint:true,
            previewCall:this.previewCall,
            printCall:this.printCall,
            showRemarks: this.state.showRemarks,
            showRemarksCall: this.showRemarksCall,
            showPublishMediaListModalBtnCall: that.showPublishMediaListModalBtnCall, // 查看发布 按钮
            showPublishMediaListModalBtn: that.state.showPublishMediaListModalBtn, // 查看发布 按钮
            undoCall: this.undoCall,
            showUndo: id&&website&&(website.statusName == "已发布" || website.statusName == "已发布" || website.statusName == "定时发布"),
            showReason:this.state.showReason,
            showDiscardReasonCall: this.showDiscardReasonCall,
        };
        if ((this.urlParams && this.urlParams.hideBtn) || this.state.isDelete) {
            buttonListData.activityOption.showBtnFlag = false;
            buttonListData.activityOption.mustNotShowPublishBtn = true;
            buttonListData.showPreview = false;
            buttonListData.showPublishMediaListModalBtn = false;
            buttonListData.showUndo = false
        }
		//删除稿件按钮显示控制
        if(this.state.isDelete) {
            buttonListData.showPrint = false;
            buttonListData.showSave = false;
        }
        if(!buttonListData.activityOption.showBtnFlag) {
            buttonListData.showUndo = false
        }
        return buttonListData;
    };

    //渲染流程按钮
    renderActBtn = () => {
        let buttonListData = this.getActBtnListData();
        let isLockedData={isLockedData:this.state.isLockedData};
        return (
            <>
                {buttonListData ?
                    (
                        <>
                            <ButtonList {...buttonListData}{...isLockedData}/>
                            <LinkCheck ref={ref => this.LinkCheck = ref}/>
                            {this.renderViewPublishModal()}
                            {this.renderUndo()}
                        </>
                    )
                    : ""}
                <SyncModal ref={ref=>this.syncModal=ref}/>
            </>
        );
    };

    renderViewPublishModal = ()=>{
        return (
            <Modal
                title={"查看发布"}
                footer={null}
                visible={this.state.publishMediaListModalVisible}
                onOk={()=>{this.setState({publishMediaListModalVisible:false})}}
                onCancel={()=>{this.setState({publishMediaListModalVisible:false})}}
                // maskClosable={false}
            >
                <Scrollbars
                    autoHeight={true}
                    autoHeightMax={500}
                    autoHide={true}
                >
                    <MediaList group={this.state.publishMediaListData} hideMediaTitle={true} showHref={true}/>
                </Scrollbars>
            </Modal>
        )
    };

    showPublishMediaListModalBtnCall = () => {
        this.setState({publishMediaListModalVisible:true});
    };

    // 渲染稿件基本信息
    renderInformation = () => {
        return(
            <EditorInformation
                // 配置文件（输入框占比）
                informationConfig={informationConfig}
                // 配置文件（输入框大小）
                formItemSizeConfig={formItemSizeConfig}
                // 基本信息展开状态
                informationStatus={this.state.informationStatus}
                // 编辑器内容
                contentText={this.state.contentText}
                // 标题的加号
                titleAddOrMinus={(call) => {
                    this.titleAddOrMinus(call)
                }}
                onLinkCheckedCall={(status)=>{
                    this.setState({editorShowStatus:status})
                }}
                formItemOnChange={(key, value)=>{//表单内容变化时通知
                    systemBaseEvent.asyncExec("editorInformationItemChange", {key, value});
                }}
                // 点击标题
                dynamicParams={{
                    editorId: this.state.id,
                    mediaId: this.state.mediaId,
                    treeId: this.state.treeId,
                    contentId: this.state.contentId,
                }}
                ref={(ref) => {
                    this.editorInformation = ref;
                    window.ueditor.getInformation = (check)=>this.editorInformation.getInformation(check);
                    window.ueditor.delAttachByMd5 = (md5)=>this.editorInformation.delAttachByMd5(md5);
                    window.ueditor.setFocus = (labelKey)=>this.editorInformation.setFocus(labelKey);
                    window.ueditor.informationSelect = (labelKey,sIndex,eIndex) => this.EditorInformation.selectText(labelKey,sIndex,eIndex);
                }}
            />
        )
    };

    // 渲染稿件栏目模块
    renderEditorPublishInformation= () => {
        return (
            <EditorPublishInformation
                ref={(ref) => {
                    this.editorPublishInformation = ref
                }}
                title={'发布设置'}
                informationConfig={publishInformationConfigFn()}
                dynamicParams={{
                    editorId: this.state.id,
                    mediaId: this.state.mediaId,
                    treeId: this.state.treeId,
                    contentId: this.state.contentId,
                    checkMainColumn: this.state.checkMainColumn,
                    setDynamicParams: this.setDynamicParams
                }}
            />
        )
    };

    setDynamicParams = (dynamicParams) => {
        if(dynamicParams) {
            for(let i in dynamicParams) {
                this.state[i] = dynamicParams[i]
            }
            this.setState({});
        }
    };

    titleAddOrMinus(call) {
        this.setState({
            informationStatus: true,
        },()=>{
            call&&call(true)
        })
    }

    /**
     * 获取稿件
     */
    getStoryById = () => {
        let that = this;
        if(!(this.props.id && this.props.id.length>1 && this.props.id != 'null' && this.props.id != 'undefined')){
            this.Editor&&this.Editor.showData&&this.Editor.showData(this.webStory);
            return;
        }
        this.request({
            url: "/cm-sites-pms/website/news/getById",
            body: {webNewsId:this.props.id},
            callBack: function (res) {
                if (res) {
                    systemBaseEvent.syncPlaybackExec("editorDataChange", res);
                    if (res && (res.statusName == "发布" || res.statusName == "已发布")) {
                        // 加载发布量
                        that.request({
                            url: "/cm-sites-pms/website/news/getNewsDetail",
                            body: {webNewsId: that.props.id},
                            callBack: function (data) {

                                //data 用的是 wbcontentid  wbshowtimes
                                let newDeliveryNews=res.deliveryNews;//contentId   wbshowtimes
                                data.forEach(newIte=>{
                                    newDeliveryNews.forEach((currentItem,index)=>{
                                        if(newIte.wbcontentid==currentItem.contentId){
                                            newDeliveryNews[index].wbshowtimes=newIte.wbshowtimes
                                        }
                                        if(newIte.wbcontentid==res.contentId){
                                            res.wbshowtimes=newIte.wbshowtimes;
                                        }
                                    })
                                });
                                res.deliveryNews=newDeliveryNews;
                                that.setStoryByData(res);
                            },errorCallBack: function (e) {
                                message.error('加载发布量失败！');
                            }
                        });
                        // 加载发布文章链接
                        that.getPublishList(res.id);
                        that.showColumnsModel(res);
                    }else{
                        that.setStoryByData(res)
                    }
                } else {
                    message.error('该稿件已删除！');
                    that.setState({isDelete:true})
                }
            },
            errorCallBack: function (res) {
                message.error('稿件加载失败！');
                that.setState({isDelete:true})
            }
        });
    };

    showColumnsModel = (data) => {
        if(data){
            if(data.statusName == "发布" || data.statusName == "已发布") {
                if(data.deliveryNews && data.deliveryNews.length) {
                    let contentId = this.urlParams.contentId ? this.urlParams.contentId*1 : "";
                    let mediaId = this.urlParams.mediaId ? this.urlParams.mediaId : "";

                    if(
                        (contentId && data.contentId && contentId!=data.contentId) ||
                        (mediaId && data.mediaId && mediaId!=data.mediaId)
                    ) {
                        //当前不是主栏目 (媒体不同时也认为不是主栏目，存在不同媒体相同栏目id的情况）
                        let that = this;
                        let deliveryWay = data.deliveryNews.find(deliveryNews=>deliveryNews.contentId==contentId);
                        deliveryWay = deliveryWay && deliveryWay['deliveryWay'];
                        if(deliveryWay===1 || deliveryWay===0) {
                            let message = "";
                            if(deliveryWay===1) {
                                message = <div>检测到该文章是在<span style={{fontWeight: 700}}>{data.mediaName}/{data.contentName}</span>栏目下发布并同时发布至当前栏目中的，是否要编辑原文章？</div>;
                            }
                            else if(deliveryWay===0) {
                                // message = <div>检测到该文章是在<span style={{fontWeight: 700}}>{data.mediaName}/{data.contentName}</span>栏目下发布并同时发布至当前栏目中的，是否要编辑原文章，或直接在当前栏目独立编辑与发布？</div>;
                                message = <div>检测到该文章是在<span style={{fontWeight: 700}}>{data.mediaName}/{data.contentName}</span>栏目下发布并同时发布至当前栏目中的，是否要编辑原文章？</div>;
                            }
                            that.syncModal.confirm({
                                title: "信息",
                                width: 600,
                                content: message,
                                okText: "确定",
                                cancelText: "取消",
                                footer: <div>
                                    <Button type={'primary'} onClick={()=>{that.syncModal.destroy();}}>编辑原文章</Button>
                                    {/*{deliveryWay===0?<Button onClick={()=>{that.syncModal.destroy();}}>在当前栏目独立编辑</Button>:""}*/}
                                    <Button onClick={()=>{window.close();}}>取消编辑</Button>
                                </div>,
                                onOk: () => {
                                    that.syncModal.destroy();
                                },
                                onCancel: () => {
                                    that.syncModal.destroy();
                                    window.close();
                                }
                            });
                        }
                    }
                }
            }
        }
    };

    getPublishList = (webNewsId)=>{
        this.request({
            url : "/cm-sites-pms/website/news/getPublishUrl",
            body: {webNewsId},
            callBack: (data) => {
                let convertData = ()=>{
                    let group = [];
                    let names = [];
                    for(let i = 0; data && i < data.length; i++){
                        let item = data[i];
                        if(item.mediaType){
                            let index = names.indexOf(item.mediaType);
                            if(index === -1){//不存在
                                if(!item.contentName){
                                    group.push({icon: item.mediaLogoUrl, type:item.mediaType, data: [{href: item.linkUrl, name:item.mediaName}]});
                                }else{
                                    group.push({icon: item.mediaLogoUrl, type:item.mediaType, data: [{href: item.linkUrl, name:item.mediaName + "/" + item.contentName}]});
                                }
                                names.push(item.mediaType);
                            }else{
                                if(!item.contentName){
                                    group[index].data.push({href: item.linkUrl, name: item.mediaName});
                                }else{
                                    group[index].data.push({href: item.linkUrl, name: item.mediaName + "/" + item.contentName});
                                }
                            }
                        }
                    }
                    return group;
                };
                let publishMediaListData = convertData();
                this.setState({showPublishMediaListModalBtn:true, publishMediaListData})
            }
        })
    };
    /**
     * 获取稿件id
     * */
    getStoryId = () => {
        return (this.props.id && this.props.id.length > 1 && this.props.id !== 'null' && this.props.id !== 'undefined') ? this.props.id : ''
    }
    /**
     * 回显数据之前需要做的事情
     * 如果当前打开的稿件存在id，但是没有查到历史记录，需要查询其是否存在关联的收稿稿件，如果有则需要用投稿稿件id重启流程，以实现两段流程的拼接效果
     * */
    processHistory=[]
    beforeSetStoryByData = (story,call) => {
        let id = this.getStoryId();
        if(id && story.id === id) { // 证明当前稿件存在并且story就是当前稿件数据
            this.getProcessHistory(id, (history) => {
                if(!history?.length) {
                    this.findOldUuid({id}).then((oldId)=>{
                        if(oldId) {
                            this.state.storyId = oldId
                        }
                        call&&call()
                    }).catch(()=>{call&&call()})
                } else {
                    this.processHistory=history
                    call&&call()
                }
            })
        } else {
            call&&call()
        }
    }
    setStoryByData = (data) => {
this.beforeSetStoryByData(data,()=>{
        this.state.website = data;
        this.webStory = data;
        this.Editor&&this.Editor.showData&&this.Editor.showData(this.webStory);
        // 回显主栏目
        let treeId= data.treeId;
        let mediaId= data.mediaId;
        let contentId= data.contentId;
        // 当前栏目和主栏目不是一码事
        // 通过session传进来的栏目id是用来自动回显栏目的，如果此时稿件数据中本身有栏目，则取稿件中的栏目id.
        // 目前编辑器中没有什么地方非要用到当前栏目是哪一个，除了新增网站稿件时需要。
        this.setMainColumn({treeId,mediaId,contentId});
        this.setIds({mediaId,treeId,contentId,checkMainColumn:false});
        // 回显表单信息
        this.setCurrentInformation(data);
        // 回显发布设置
        this.setPublish({
            selectColumn: {
                deliveryNews: data.deliveryNews||[],
                mainColumn: {
                    treeId: data.treeId,
                    treeName: data.treeName,
                    mediaId: data.mediaId,
                    mediaName: data.mediaName,
                    contentId: data.contentId,
                    contentName: data.contentName,
                }
            },
            synchronousContribute: data.targetIds,
            otherAttributes: {
                // 发布时间
                "newdate": data.newdate,
                // 下线时间
                "wbenddate": data.wbenddate,
                // 重要性 int
                "wbweight": data.wbweight,
                // 是否头条 int
                "wbfirst": data.wbfirst,
                // 头条结束时间
                "wbfirstenddate": data.wbfirstenddate,
                // 头条开始时间
                "wbfirststartdate": data.wbfirststartdate,
                // 是否置顶 int
                "wbtop": data.wbtop,
                // 置顶开始时间
                "wbtopdate": data.wbtopdate,
                // 置顶结束时间
                "wbgotopdate": data.wbgotopdate,
                // 是否推荐 int
                "wbrecommend": data.wbrecommend,
                // 量 int
                "wbshowtimes": data.wbshowtimes,
            },
            otherSetting: {
                wbiscomment: data.variableFields?(data.variableFields.wbiscomment):0,
                wbcopyenable: data.variableFields?(data.variableFields.wbcopyenable):0,
                wbsecurity: data.variableFields?(data.variableFields.wbsecurity):0,
            }
        });
        if(data.variableFields?.recycle&&(data.variableFields.recycle ==="1" || data.variableFields.recycle ==="2" )) {
            this.setState({isDelete:true})
        }
        // 回显编辑器内容
        this.setContent(data.content);
        // 重置流程参数
        this.initActivitiConfig(data);
        if (data.deliveryNews && data.deliveryNews.length > 0) {
            this.setState({
                hasMore: true,
                deliveryNews: data.deliveryNews
            })
        }
})
    };
    //预览
    previewCall=()=>{
        if(!this.state.id) return message.warning('请先保存，再预览');
        if(!this.state.contentId) return message.warning('未找到当前稿件所在栏目，请在对应栏目下查看');
        // message.info('温馨提示：先保存再预览');
        this.request({
            url:'/cm-sites-pms/website/news/getPreviewParam',
            body:{contentId:this.state.contentId,webNewsId:this.state.id},
            callBack:(res)=>{
                if (res){
                    this.openLoginPage(res.url,
                        {
                            account:res.account,
                            token:res.token,
                            action:res.action,
                            newsid:res.newsid,
                            type:res.type,
                            owners:res.owners,
                        }
                    )
                }
            }
        })
    };
    //预览
    openLoginPage(URL, PARAMTERS) {
        //创建form表单
        var temp_form = document.createElement("form");
        temp_form.action = URL;
        //如需打开新窗口，form的target属性要设置为'_blank'
        temp_form.target = "_self";
        temp_form.method = "post";
        temp_form.style.display = "none";
        temp_form.target = "_blank";
        //添加参数
        for (var key in PARAMTERS) {
            var opt = document.createElement("textarea");
            opt.name = key;
            opt.value = PARAMTERS[key];
            temp_form.appendChild(opt);
        }
        document.body.appendChild(temp_form);
        //提交数据
        temp_form.submit();
    };
    // 打印回调
    printCall = () => {
        let story = this.webStory;
        if(!this.state.id && !(story && story.title)) return message.warning('请先保存，再打印');
        if(!this.state.id) {
            window.openPage({
                url: "/cm-sites/pms/printHtmlDetail.html",
                params: story,
            });
        } else {
            let url = this.toCode("/cm-sites-pms/website/news/getById?webNewsId="+this.state.id);
            let printUrl='/cm-sites/pms/printHtmlDetail.html?url='+url; // +'&download=true' 直接下载
            window.open(printUrl)
        }
    };

    // 查看编辑回调
    showRemarksCall = () =>{
        let that = this;
        that.syncModal.confirm({
            title: "备注",
            width: 400,
            content: <TextArea value={that.state.remarks} placeholder={"请输入"} maxLength={200} rows={2}
                               style={{width: 350, height: 64, fontSize: 14}}
                               ref={(remarksTextArea) => that.remarksTextArea = remarksTextArea}/>,
            okText: "确定",
            cancelText: "取消",
            footer: <Button onClick={()=>{that.syncModal.destroy();}}>关闭</Button>,
            onOk: () => {
                that.syncModal.destroy();
            },
            onCancel: () => {
                that.syncModal.destroy();
            }
        });
    }

    //查看弃用原因
    showDiscardReasonCall = () =>{
        let that = this;
        that.syncModal.confirm({
            title: "弃用原因",
            width:400,
            content:<div>
                {that.state.discardReasonList.map((item, index) => (
                    <DiscardReason isEdit={false} data={item}/>
                ))}
            </div>,
            okText: "确定",
            cancelText: "取消",
            footer: <Button onClick={()=>{that.syncModal.destroy();}}>关闭</Button>,
            onOk: ()=>{
                that.syncModal.destroy();
            },
            onCancel: ()=>{
                that.syncModal.destroy();
            }
        });
    };

    // 字符串加密
    toCode (str) {
        //定义密钥，36个字母和数字
        var key = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        var len = key.length;  //获取密钥的长度
        var a = key.split("");  //把密钥字符串转换为字符数组
        var s = "",b, b1, b2, b3;  //定义临时变量
        for (var i = 0; i <str.length; i ++) {  //遍历字符串
            b = str.charCodeAt(i);  //逐个提取每个字符，并获取Unicode编码值
            b1 = b % len;  //求Unicode编码值得余数
            b = (b - b1) / len;  //求最大倍数
            b2 = b % len;  //求最大倍数的于是
            b = (b - b2) / len;  //求最大倍数
            b3 = b % len;  //求最大倍数的余数
            s += a[b3] + a[b2] + a[b1];  //根据余数值映射到密钥中对应下标位置的字符
        }
        return s;  //返回这些映射的字符
    }

    publishData = {};

    checkForm = (activiti, call) => {
        message.destroy();
        let that = this;
        let statusNameTemp = activiti && activiti.options && activiti.options.statusNameTemp || "";
        let activitiConfName = that.sysConfigGetValueByKey("editor.activiti.publish.states", "发布,已发布");
        let isPublish = statusNameTemp && activitiConfName.indexOf(statusNameTemp)>-1;

        // 获取编辑器内容===================start
        let content = this.getEditContent();

        // 获取编辑器内容 ================end

        // 获取基础属性====================start
        let currentInformation = this.getCurrentInformation();
        if(!currentInformation) {// 基本信息校验
            window.loading.hide();
            return false
        }
        if(this.webStory.variableFields){
            currentInformation.variableFields.formatId = this.webStory.variableFields.formatId;
        }
        // 获取基础属性========================end

        // 跳转链接
        if(currentInformation.linkurl&&currentInformation.linkurl.length>0){
            content = ""
        } else {
            if(!content) {
                window.loading.hide();
                message.warning("请填写内容！");
                return false
            }
            if(content.indexOf("wordimg.png") !== -1){
                window.loading.hide();
                message.warning("存在从word中复制的不可用的图片，请单独复制图片进行替换");
                return false
            }
        }

        // 获取稿件id
        let id = (this.state.id && this.state.id != '0') ? this.state.id : '';

        // 获取发布设置start
        let publishData = this.getPublish();
        let {selectColumn, synchronousContribute=[],otherAttributes={}} = publishData;
        if(!selectColumn) {
            return false
        }
        let mainColumn = selectColumn&&selectColumn.mainColumn||{}; // 主栏目
        let contentId = mainColumn.contentId||this.state.contentId;
        let contentName = mainColumn.contentName||this.state.contentName;
        let treeId = mainColumn.treeId||this.state.treeId;
        let treeName = mainColumn.treeName||this.state.treeName;
        let mediaId = mainColumn.mediaId||this.state.mediaId;
        let mediaName = mainColumn.mediaName||this.state.mediaName;
        let deliveryNews = selectColumn&&selectColumn.deliveryNews||[]; // 同步发布栏目

        // 发布时校验下线时间
        if(isPublish && otherAttributes.wbenddate) {
            if(otherAttributes.wbenddate < Date.now()) {
                window.loading.hide();
                message.warning("下线时间不能早于当前时间");
                return false
            }
        }
        // 获取发布设置end
        // 栏目信息校验
        // 网站稿件编辑器在推进的时候必须选择主栏目，否则稿件丢失
        if(!(mainColumn && contentId && treeId && mediaId)) {
            window.loading.hide();message.warning("请先选择主栏目");
            return false
        }
        call&&call()
    };

    /**
     * 稿件保存
     */
    saveStory = (activiti, call) => {
        message.destroy();
        let that = this;
        let statusNameTemp = activiti && activiti.options && activiti.options.statusNameTemp || "";
        let activitiConfName = that.sysConfigGetValueByKey("editor.activiti.publish.states", "发布,已发布");
        let isPublish = statusNameTemp && activitiConfName.indexOf(statusNameTemp)>-1;

        // activiti&&activiti.load&&activiti.load.start();
        // 获取编辑器内容===================start
        let content = this.getEditContent();

        // 获取编辑器内容 ================end

        // 获取基础属性====================start
        let currentInformation = this.getCurrentInformation();
        if(!currentInformation) {// 基本信息校验
            window.loading.hide();
            call&&call(false);
            return false
        }
        // let {information, dynamicParams} = currentInformation;
        // dynamicParams = dynamicParams || {};
        if(this.webStory.variableFields){
            currentInformation.variableFields.formatId = this.webStory.variableFields.formatId;
        }
        // 获取基础属性========================end

        // 跳转链接
        if(currentInformation.linkurl&&currentInformation.linkurl.length>0){
            content = ""
        } else {
            if(!content) {
                window.loading.hide();
                message.warning("请填写内容！");
                call && call(false);
                return false
            }
            if(content.indexOf("wordimg.png") !== -1){
                window.loading.hide();
                message.warning("存在从word中复制的不可用的图片，请单独复制图片进行替换");
                call&&call(false);
                return false
            }
        }

        // 获取稿件id
        let id = (this.state.id && this.state.id != '0') ? this.state.id : '';

        // 获取发布设置start
        let publishData = this.getPublish();
        let {selectColumn, synchronousContribute=[],otherAttributes={}} = publishData;
        if(!selectColumn) {
            call&&call(false);
            return false
        }
        let mainColumn = selectColumn&&selectColumn.mainColumn||{}; // 主栏目
        let contentId = mainColumn.contentId||this.state.contentId;
        let contentName = mainColumn.contentName||this.state.contentName;
        let treeId = mainColumn.treeId||this.state.treeId;
        let treeName = mainColumn.treeName||this.state.treeName;
        let mediaId = mainColumn.mediaId||this.state.mediaId;
        let mediaName = mainColumn.mediaName||this.state.mediaName;
        let deliveryNews = selectColumn&&selectColumn.deliveryNews||[]; // 同步发布栏目

        // 发布时校验下线时间
        if(isPublish && otherAttributes.wbenddate) {
            if(otherAttributes.wbenddate < Date.now()) {
                window.loading.hide();
                message.warning("下线时间不能早于当前时间");
                call&&call(false);
                return false
            }
        }
        // 如果是已发布状态，并且现在又要定时发布，则不允许发布
        if(isPublish && this.state?.website?.statusName === "已发布" && otherAttributes?.newdate > Date.now()) {
            window.loading.hide();
            call&&call(false);
            message.destroy();
            message.warning("您设置的发布时间大于当前时间，请撤稿后再发布");
            return false
        }
        // 获取发布设置end
        // 栏目信息校验
        // 网站稿件编辑器在推进的时候必须选择主栏目，否则稿件丢失
        if(!(mainColumn && contentId && treeId && mediaId)) {
            window.loading.hide();
            call&&call(false);
            message.destroy();
            message.warning("请先选择主栏目");
            return
        }
        // 存储其他设置
        let {otherSetting={}} = publishData;
        currentInformation.variableFields = {
            ...(currentInformation.variableFields||{}),
            ...otherSetting
        };
        window.loading.hide();
        this.LinkCheck.show(content,(res)=>{
            window.loading.show();
            if(res) {
                if(res.content) {
                    this.setContent(res.content);
                }
                if(res.status) {
                    // 稿件数据 start
                    let params = {
                        /**
                         * 表单设置==============================start
                         */
                        // // 文章标题
                        // "title": currentInformation.title,
                        // // 附件
                        // "attach": currentInformation.attach,
                        // // 主栏目标题图
                        // "titlePic": currentInformation.titlePic,
                        // // 可变字段
                        // "variableFields": currentInformation.variableFields,
                        // // 站群字段
                        // "wbextends": currentInformation.wbextends,
                        ...currentInformation,
                        /**
                         * 表单设置==================================end
                         */
                        //同步投递
                        "targetIds":synchronousContribute,
                        // 正文
                        "content": base64Encode(removeContentSecurity(res.content || content)),
                        //跳转链接
                        "linkurl":currentInformation.linkurl,
                        // 稿件id
                        "id": id,
                        // 投递信息（副栏目信息）
                        "deliveryNews": deliveryNews,
                        /**
                         * 主栏目设置==============================start
                         */
                        // 主媒体id
                        "mediaId": mediaId,
                        // 主媒体名
                        "mediaName": mediaName,
                        // 主栏目Id int
                        "treeId": treeId,
                        // 主栏目名
                        "treeName": treeName,
                        // 主资料源id int
                        "contentId": contentId,
                        // 主资料源名称
                        "contentName": contentName,
                        // 发布时间
                        "newdate": otherAttributes.newdate,
                        // 下线时间
                        "wbenddate": otherAttributes.wbenddate,
                        // 重要性 int
                        "wbweight": otherAttributes.wbweight,
                        // 是否头条 int
                        "wbfirst": otherAttributes.wbfirst,
                        // 头条结束时间
                        "wbfirstenddate": otherAttributes.wbfirstenddate,
                        // 头条开始时间
                        "wbfirststartdate": otherAttributes.wbfirststartdate,
                        // 是否置顶 int
                        "wbtop": otherAttributes.wbtop,
                        // 置顶开始时间
                        "wbtopdate": otherAttributes.wbtopdate,
                        // 置顶结束时间
                        "wbgotopdate": otherAttributes.wbgotopdate,
                        // 是否推荐 int
                        "wbrecommend": otherAttributes.wbrecommend,
                        // 量 int
                        "wbshowtimes": otherAttributes.wbshowtimes,
                        /**
                         * 主栏目设置==================================end
                         */
                    };
                    if(!params.id) {
                        // 新增稿件添加创建人
                        systemBaseEvent.syncExec("editorAddData");
                        let currentUser = window.currentUser ? window.currentUser : {};
                        params={
                            ...params,
                            "creator": currentUser.id,
                            "creatorName": currentUser.name,
                        };
                    } else {
                        params={
                            ...params,
                            "creator": this.webStory.creator,
                            "creatorName": this.webStory.creatorName,
                        };
                        systemBaseEvent.syncExec("editorUpdateData");
                    }

                    // 稿件数据 end
                    let url = '/cm-sites-pms/website/news/save';
                    // 获取发布状态
                    let autoSaveStatsConfName = that.sysConfigGetValueByKey("webNew.activiti.autoSave.states", "发布,已发布,修改完成并提交");
                    let autoSaveStats = statusNameTemp && autoSaveStatsConfName.indexOf(statusNameTemp)>-1;
                    if(autoSaveStats) {
                        url = '/cm-sites-pms/website/news/autoSave';
                    }
                    if(this.publishData?.dbUpdateTime) {
                        // 已经保存过，再次进行保存，需要更新保存时间
                        params.dbUpdateTime = this.publishData.dbUpdateTime
                    }
                    this.request({
                        url,
                        method: 'POST',
                        body: params,
                        contentType: 'json',
                        loading:false,
                        callBack: async (res) => {
                            if (res) {
                                that.urlParams.treeId = res.treeId;
                                that.urlParams.mediaId = res.mediaId;
                                that.urlParams.contentId = res.contentId;
                                that.setParentParams(that.urlParams);

                                // 备注，这里必须这样写，稿件保存时不会回显同步投递的参数，但是发布时需要
                                this.publishData = {...params,...res,content: base64Encode(removeContentSecurity(res.content))};
                                // 更新稿件关系（网站稿件与收稿稿件
                                if(that.urlParams && that.urlParams.storyId) {
                                    that.updateStoryRelationByContent({
                                        body: {
                                            mediaNewsId: res.id, // 网站稿件id
                                            mediaNewsType: "webNews", // 网站媒体type
                                            operateType: that.state.operateType, // contribute 点击素材中心标题 / pickUp 点击拾取器
                                            storyId: that.urlParams.storyId, // 原稿件Id(副本）
                                        }
                                    });
                                }
                                this.state.id = res.id;
                                // window.loading.hide();
                                systemBaseEvent.syncExec("editorDataChange", res);
                                systemBaseEvent.syncExec("editorIdChange", {editorId: this.state.id});
                                let funs = window.ueditor.afterSaveDataFun;
                                for(let i = 0 ; funs && i < funs.length; i++){
                                    let fun = funs[i];
                                    if(fun instanceof Promise){
                                        await fun(activiti, res, call);
                                    }else{
                                        fun(activiti, res, call);
                                    }
                                }
                                this.state.website = res;
                                this.webStory = res;
                                // let statusNameTemp = activiti && activiti.options && activiti.options.statusNameTemp || "";
                                // // 获取发布状态
                                // let activitiConfName = that.sysConfigGetValueByKey("editor.activiti.publish.states", "发布,已发布");
                                if(isPublish) {
                                    // params.id = this.state.id;
                                    // this.securityCheckAsyncCheckAndPublish(params, activiti, res, call);
                                    this.securityCheckAsyncCheck({params, activiti, website:res, call});
                                }else{
                                    this.securityCheckAsyncCheck({params, activiti, website:res, call});
                                }
                                this.updateProcessAndData(this.publishData)
                            } else {
                                message.error('保存失败！');
                                call && call(false);
                            }
                        },
                        errorCallBack: function (e) {
                            call && call(false);
                            message.error('保存失败！');
                        },
                        serverVerify: {
                            serverErrorCallBack: (e,allData) => {
                                window.loading.hide();
                                call && call(false);
                            }
                        }
                    });
                } else {
                    window.loading.hide();
                    call && call(false);
                    return false
                }
            }
        });
    };

    // 更新稿件关系(拾取、复制）
    updateStoryRelationByContent = (config,call) => {
        if(config) {
            if(config.body) {
                this.request({
                    url:"/cm-sites-pms/story/saveRelation",
                    method:"post",
                    body: config.body,
                    callBack: (res) => {
                        if(res) {
                            call&&call(true);
                        }
                    }
                })
            }
        } else {
            call&&call(false);
        }
    };

    // 更新流程稿件
    updateProcessAndData = (body) => {
        this.request({
            url: "/cm-sites-sys/process/updateProcessAndData",
            method: "post",
            contentType: "json",
            body: {
                title: body?.title,
                bizKey: body?.id,
                data: body,
            },
            callBack: (res)=>{

            }
        })
    };

    securityCheckAsyncCheckAndPublish = (params, activiti, res, call)=>{
        this.securityCheckAsyncCheck({params, activiti, website:res, call:(website)=>{
            let url = '/cm-sites-pms/website/news/publish';
            this.request({
                url,
                method: 'POST',
                body: params,
                contentType: 'json',
                callBack: () => {
                    call && call(website);
                },
                errorCallBack: function (e) {
                    call && call(false);
                    // message.error('发布失败！');
                }
            });
        }, successMsg:()=>{
            // message.success('发布成功！');
        }});
    };

    securityCheckAsyncCheck = ({params, activiti, website, call, successMsg = (that, activiti)=>{
        if(!activiti){//点了暂存按钮
            message.success('保存成功！',0.5,()=>{
                that.refresh()
            });
        }
    }})=>{
        let that = this;
        // 某些状态不需要检测敏感词start
        let noDetectionStatus = this.sysConfigGetValueByKey("no.detection.story.statusName", "返回,弃用").split(',');
        let statusNameTemp = activiti && activiti.options && activiti.options.statusNameTemp || "";
        console.log(noDetectionStatus,statusNameTemp,activiti);
        // let needDetectionStatus = this.sysConfigGetValueByKey("need.detection.story.statusName", "发布,全部").split(',');
        if (statusNameTemp && noDetectionStatus && noDetectionStatus.some(item => statusNameTemp.indexOf(item) > -1)) {
            call && call(website);
            that.state.id = website.id;
            successMsg(that, activiti);
            return
        }
        // if(!(statusNameTemp && noDetectionStatus && ((needDetectionStatus.indexOf("全部") > -1) || needDetectionStatus.some(item => statusNameTemp.indexOf(item) > -1)))){
        //     call && call(website);
        //     that.state.id = website.id;
        //     successMsg(that, activiti);
        //     return false
        // }
        // 某些状态不需要检测敏感词end
        if(this.getNeedCheck(activiti)) {
            if(!window.ueditor.securityCheckAsyncCheck){
                message.warn("敏感词检测失效，无法进行异步检测");
            }else {
                window.ueditor.securityCheckAsyncCheck((content) => {
                    window.loading.show();
                    call && call(website);
                    that.state.id = website.id;
                    successMsg(that, activiti);
                }).catch(() => {
                    call && call(false);
                    message.error('敏感词检测失败！');
                });
            }
        } else {
            call && call(website);
            that.state.id = website.id;
            successMsg(that, activiti);
            return false
        }
    };
    getNeedCheck = (activiti) => {
        let btnName = activiti?.options?.item?.btnName;
        let name = activiti?.options?.item?.name;
        let statusNameTemp = activiti?.options?.statusNameTemp;
        // 获取需要检测的状态
        let needDetectionStatus = this.sysConfigGetValueByKey("need.detection.story.statusName", "发布").split(',');
        // let needDetectionStatus = ["发布","全部"];
        // if (!(
        //     needDetectionStatus &&
        //     ((statusNameTemp && needDetectionStatus.some(item => statusNameTemp.indexOf(item) > -1))
        //         || (needDetectionStatus.indexOf("全部") > -1))
        // )) {
        //     return false
        // }
        if(!needDetectionStatus?.length) {
            return false
        }
        if(!activiti) {
            // 暂存
            return (
                needDetectionStatus.indexOf("暂存") > -1 ||
                needDetectionStatus.indexOf("保存") > -1
            )
        }
        if(btnName || name || statusNameTemp) {
            return (
                needDetectionStatus.indexOf(btnName) > -1 ||
                needDetectionStatus.indexOf(name) > -1 ||
                needDetectionStatus.indexOf(statusNameTemp) > -1 ||
                needDetectionStatus.indexOf("全部") > -1
            )
        }
        return false
    };
    /**
     * 稿件修改状态
     */
    updateStatusName=(statusName, activiti, call)=> {
        let that = this;
        let id = (this.state.id && this.state.id != '0') ? this.state.id : '';
        let params = {
            "webNewsId": id,
            "statusName":statusName,
        };
        this.request({
            url: '/cm-sites-pms/website/news/saveStatusName',
            method: 'POST',
            body: params,
            loading:false,
            callBack: function (res) {
                if (res) {
                    call&&call({status: true, msg: "流程推进后状态修改成功。"});
                    // that.state.id=res.id;
                } else {
                    call&&call({status: false, msg: "流程推进后状态修改失败。"});
                }
            },
            errorCallBack: function (res) {
                call&&call({status: false, msg: "流程推进后状态修改失败。"});
            }
        });
    };

    publish = (statusName, activiti, call) => {
        if(this.publishData && this.publishData.id) {
            let url = '/cm-sites-pms/website/news/publish';
            this.request({
                url,
                method: 'POST',
                body: this.publishData,
                contentType: 'json',
                loading:false,
                callBack: () => {
                    call&&call({status: true, msg: "流程推进后发布成功。"});
                },
                errorCallBack: function (e) {
                    call&&call({status: false, msg: "流程推进后发布失败。"});
                }
            });
        } else {
            message.warn("发布失败！稿件id丢失")
        }

    };

    setMainColumn = ({
                         treeId = this.state.treeId,
                         mediaId = this.state.mediaId,
                         contentId = this.state.contentId,
                     }) => {
        this.setState({treeId,mediaId,contentId})
    };

    //获取编辑器内容（所有）
    getEditContent() {
        let contentTxt = this.getEditContentText();
        let content = window.ueditor.getContent();
        if(
            !(contentTxt && contentTxt.length) &&
            !(content.indexOf("img") > -1 || content.indexOf("IMG") > -1)
        ) {
            return false
        }
        return content
    }
    //获取编辑器内容（文字）
    getEditContentText() {
        return window.ueditor.getContentTxt();
    }
    //设置编辑器内容
    setContent(content) {
        if (content) {
            window.ueditor.setContent(content)
        }
    }

    //获取稿件基本信息
    getCurrentInformation() {
        return this.editorInformation.getInformation();
    }
    //设置稿件基本信息
    setCurrentInformation(data) {
        this.editorInformation.setInformation(data)
    }

    /**
     * 右侧栏目的设置与获取方法start
     * */
    setPublish = (data) => {
        if(this.editorPublishInformation){
            console.log("this.editorPublishInformation:       ", this.editorPublishInformation);
        }else{
            console.log("this.editorPublishInformation:       null`````````````");
        }
        this.editorPublishInformation.setData(data)
    };
    getPublish = (data) => {
        return  this.editorPublishInformation.getData(data)
    };
    /**
     * 右侧栏目的设置与获取方法end
     * */

    undoCall = () => {
        this.setState({
            undo: true
        })
    }

    renderUndo = () => {
        let { hasMore, contentId, mediaId, deliveryNews, contentName, mediaName } = this.state
        let title = hasMore ? '该文章同时发布到多个栏目，请问需要同步撤除其他栏目吗？' : '确定要撤稿吗？';
        return (
            <>
            <RmtPopconfirm
                    visible={this.state.undo}
                    title={<div style={{ marginLeft: 10 }}>{title}</div>}
                    icon={<Icon type={'question-circle'}
                        style={{ color: '#faad14', fontSize: 22 }} />}
                    footer={
                        <div style={{ display: 'flex', justifyContent: 'flex-end', }}>
                            <Button onClick={() => {
                                this.setState({ undo: false })
                            }}>取消</Button>
                            {
                                hasMore ?
                                    <Button onClick={() => {
                                        this.state.treeWithdrawData = [];
                                        // let deliveryNewsData = [...deliveryNews, {
                                        //     contentId:contentId,
                                        //     mediaId: mediaId,
                                        //     contentName:contentName,
                                        //     mediaName: mediaName,
                                        // }];
                                        this.setTreeWithdrawData(deliveryNews);
                                        this.setState({
                                            renderWithdrawModalTitle: '选择需要撤稿的栏目',
                                            treeNodeWithdrawVisible: true,
                                            undo: false
                                        })
                                    }}>选择栏目</Button>
                                    : null
                            }
                            {/* {
                                (hasMore && this.state.isMyManuscript) ?
                                    <Button onClick={() => {
                                        let treeContentIds = contentId;
                                        this.setState({undo:false});
                                        this.doStoryState(treeContentIds, 'undo')
                                    }}>当前栏目</Button>
                                    : null
                            } */}
                            {
                                hasMore ?
                                    <Button onClick={() => {
                                        let treeContentIds = contentId;
                                        this.setState({ undo: false });
                                        this.doStoryState(treeContentIds, 'undo')
                                    }}>当前栏目</Button>
                                    : null
                            }
                            <Button onClick={() => {
                                let treeContentIds = contentId;
                                if (deliveryNews && deliveryNews.length) {
                                    deliveryNews.forEach(item => {
                                        treeContentIds += (',' + item.contentId)
                                    })
                                }
                                this.setState({ undo: false });
                                this.doStoryState(treeContentIds, 'undo')
                            }} type={'primary'}>{hasMore ? '全部撤稿' : '撤稿'}</Button>
                        </div>
                    }
                >

                </RmtPopconfirm>
                {this.renderWithdrawModal()}
            </>
        )
    };

    // 稿件状态修改，栏目选择弹窗
    renderWithdrawModal = () => {
        const { treeWithdrawData } = this.state;
        return (
            <Modal
                centered={true}
                title={this.state.renderWithdrawModalTitle}
                visible={this.state.treeNodeWithdrawVisible}
                onOk={() => {
                    this.onStoryStateOk()
                }}
                onCancel={() => {
                    this.setState({ treeNodeWithdrawVisible: false, checkedWithdrawKeys: [] })
                }}
                width={400}
            >
                <Scrollbars style={{ height: 350, }}>
                    {(treeWithdrawData && treeWithdrawData.length) ? <Tree
                        showIcon
                        checkable
                        defaultExpandParent={true}
                        defaultExpandAll={true}
                        // expandedKeys={this.state.expandedKeys}
                        autoExpandParent={true}
                        checkedKeys={this.state.checkedWithdrawKeys}
                        // selectedKeys={this.state.selectedKeys}
                        // onExpand={this.onExpand}
                        // onSelect={this.onSelect}
                        onCheck={this.onWithdrawCheck}
                    >
                        {this.renderWithdrawTreeNodes(treeWithdrawData)}
                    </Tree> : null}
                </Scrollbars>
            </Modal>
        )
    };

    renderWithdrawTreeNodes = (data) =>
        data.map(item => {
            if (item.child) {
                return (
                    <TreeNode disabled={true} title={this.renderWithdrawTitle("folder-open", item)} key={item.id}
                        dataRef={item}>
                        {this.renderWithdrawTreeNodes(item.child)}
                    </TreeNode>
                );
            }
            return <TreeNode key={item.id} title={this.renderWithdrawTitle("file-text", item)} />;
        });


    renderWithdrawTitle = (type, item) => {
        return (
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: 190, }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <Icon type={type} />
                    <span style={{
                        width: 160,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                    }}
                    >{item.name}</span>
                </div>
            </div>
        )
    };

    // 稿件状态操作，节点选择弹窗确认事件
    onStoryStateOk = (time) => {
        if (this.state.checkedWithdrawKeys && this.state.checkedWithdrawKeys.length) {
            let treeContentIds = this.state.checkedWithdrawKeys.join(',');
            this.state.treeNodeWithdrawVisible = false;
            this.state.checkedWithdrawKeys = [];
            this.doStoryState(treeContentIds, this.state.urlKey, time)
        }
    };

    // 稿件状态修改（置顶头条推荐）栏目选择
    onWithdrawCheck = (checkedWithdrawKeys, info) => {
        let newChecked = checkedWithdrawKeys;
        // console.log('newChecked       ', newChecked);
        // console.log('this.state.record       ', this.state.record);
        if (checkedWithdrawKeys && checkedWithdrawKeys.length && (checkedWithdrawKeys.indexOf(this.state.contentId + '') > -1)) {
            newChecked = [this.state.record.contentId, ...this.state.record.deliveryNews.map(item => item.contentId)];
            message.info('选择主节点后会默认选中其他节点')
        }
        this.setState({ checkedWithdrawKeys: newChecked })
    };

    setTreeWithdrawData = (deliveryNews, config = {}) => {
        deliveryNews.forEach(item => {
            let index = this.state.treeWithdrawData.findIndex(item2 => item2.id == item.mediaId);
            if (item[config.key] == config.val) {
                if (index < 0) {
                    this.state.treeWithdrawData.push({
                        id: item.mediaId,
                        name: item.mediaName,
                        child: [
                            {
                                id: item.contentId,
                                name: item.contentName,
                            }
                        ]
                    })
                } else {
                    let index2 = this.state.treeWithdrawData[index].child.findIndex(item3 => item3.id == item.contentId);
                    if (index2 < 0) {
                        this.state.treeWithdrawData[index].child.push({
                            id: item.contentId,
                            name: item.contentName,
                        })
                    }
                }
            }
        });
    };

    //稿件状态操作
    doStoryState = (treeContentIds, time) => {
        let url = '/cm-sites-pms/website/news/undo';
        if (!url) return false;
        let body = { treeContentIds, webNewsId: this.state.id };
        if (time) body = { ...body, ...time };
        this.request({
            url,
            method: 'post',
            body,
            callBack: (res) => {
                if (res) {
                    message.success('操作成功');
                    this.refresh()
                    this.updateProcessAndData(res);
                }
            }
        })
    };

}